import { buildOffersPageLink } from "@garimpa/lib/buildOffersPageLink";
import {
  featurePageSearchCtaQuerySchema,
  type FeaturePageSearchCtaQuery,
} from "@garimpa/lib/featurePage";
import { getSearchSerialization } from "@garimpa/lib/searchSerialization";

const { stringifySearch } = getSearchSerialization();

export function buildFeaturePageSearchHref(input: FeaturePageSearchCtaQuery): string {
  const query = featurePageSearchCtaQuerySchema.parse(input);
  if (canUseOffersPage(query)) {
    return buildOffersPageLink({
      artistIds: query.artistIds,
      genre: query.genre ? [query.genre] : undefined,
      style: query.style ? [query.style] : undefined,
      format: query.format ?? "all",
    });
  }

  return `/search${stringifySearch({
    q: query.q,
    genre: query.genre,
    type: query.albumType,
    style: query.style,
    format: query.format,
    country: query.country,
    origin: query.origin,
    year: query.year,
    label: query.labels,
    company: query.company,
  })}`;
}

function canUseOffersPage(query: FeaturePageSearchCtaQuery): boolean {
  const unsupportedValues = [
    query.q,
    query.albumType,
    query.country,
    query.origin,
    query.year,
    query.labels?.length,
    query.company?.length,
  ];
  return unsupportedValues.every((value) => value === undefined || value === 0);
}
